import React from 'react';
import PropTypes from 'prop-types';
import { ratingTypes } from '../../../utils/constants';
import styles from '../search.scss';

const PlayersHeaderColumns = props => {
    const {
        filterType,
        players,
        utrType,
        userLoggedIn,
        sportTypes,
        showFilterDropDown,
        showHeaderColumnsInMobile,
        isClubMemberOrAdmin,
        sortClubMembers,
        isMobileView,
        sortValueForClubs,
        isItGlobalSearch,
    } = props;

    let tennis;
    let pickleball;
    if (sportTypes) {
        ({ tennis, pickleball } = sportTypes);
    }
    let sortValue = '';
    if (players?.sort?.field) {
        sortValue = `${players.sort.field}_${players.sort.asc ? 'asc' : 'desc'}`;
    }
    if (sortClubMembers) {
        sortValue = sortValueForClubs;
    }
    const sortOptions = [
        { value: 'lastName_asc', label: 'Name: A to Z' },
        { value: 'lastName_desc', label: 'Name: Z to A' },
    ];
    const UtrSortOptions = [{ value: 'singlesUtr_asc', label: `Singles ${ratingTypes.tennis}: Low to high` },
    { value: 'singlesUtr_desc', label: `Singles ${ratingTypes.tennis}: High to low` },
    { value: 'doublesUtr_asc', label: `Doubles ${ratingTypes.tennis}: Low to high` },
    { value: 'doublesUtr_desc', label: `Doubles ${ratingTypes.tennis}: High to low` },
    ];

    const PkbSortOptions = [
        { value: 'singlesPkbRating_asc', label: `Singles ${ratingTypes.pickleball}: Low to high` },
        { value: 'singlesPkbRating_desc', label: `Singles ${ratingTypes.pickleball}: High to low` },
        { value: 'doublesPkbRating_asc', label: `Doubles ${ratingTypes.pickleball}: Low to high` },
        { value: 'doublesPkbRating_desc', label: `Doubles ${ratingTypes.pickleball}: High to low` },
    ];

    if (tennis) {
        sortOptions.push(...UtrSortOptions);
    }
    if (pickleball) {
        sortOptions.push(...PkbSortOptions);
    }

    const sort = (val) => {
        const sortBy = val.split('_');
        props.sortResults('players', sortBy[0], sortBy[1]);
    };

    const getSinglesSortField = () => {
        return utrType === 'sanctioned' ? 'singlesUtr' : 'myUtrSingles';
    };

    const getDoublesSortField = () => {
        return utrType === 'sanctioned' ? 'doublesUtr' : 'myUtrDoubles';
    };
    const getSinglePkbSortField = () => {
        return 'singlesPkbRating';
    };
    const getDoublesPkbSortField = () => {
        return 'doublesPkbRating';
    };

    function sortDefaultDesc(type, field) {
        if (players.sort.field !== field || (players.sort.field === field && players.sort.asc)) {
            props.sortResults(type, field, 'desc');
        } else {
            props.sortResults(type, field, 'asc');
        }
    }

    let gridTemplateColumns;
    if (showHeaderColumnsInMobile) {
        if (tennis && pickleball) {
            gridTemplateColumns = '1fr 1fr 1fr 1fr';
        } else if (tennis || pickleball) {
            gridTemplateColumns = '1fr 1fr';
        }
    } else if (tennis && pickleball) {
        gridTemplateColumns = '1fr  1fr 1fr 1fr 1fr';
    } else if (tennis || pickleball) {
        gridTemplateColumns = ' 1fr 1fr 1fr';
    } else if (!userLoggedIn) {
        gridTemplateColumns = '1fr 1fr 1fr 1fr 1fr';
    } else {
        gridTemplateColumns = '1fr 1fr 1fr';
    }

    return (
        (players && players.total > 0) || (isClubMemberOrAdmin && players?.length > 0)
            ? (
                <div>
                    {!sortClubMembers && (
                        <div className={`${styles.searchHeaders} ${showHeaderColumnsInMobile ? 'd-flex d-md-none mt20 mb2' : 'd-none d-md-flex'} `} data-testid="search.players.column-headers">
                            <div className="flex-grow w-90" data-testid="search.players.column-headers-inner">
                                <div className={`row ${isClubMemberOrAdmin ? 'pl0' : ''}`}>
                                    {isItGlobalSearch && (
                                        <div className={`text-small col-sm-auto ${showHeaderColumnsInMobile ? 'd-none' : ''} ${styles.searchHeaderColumn}`} data-testid="search.players.column-header.rank">&#35;</div>
                                    )}
                                    <div
                                        className={`text-small col-sm-5 ${showHeaderColumnsInMobile ? 'd-none' : ''} ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && players.sort.field === 'lastName' ? 'active' : ''}`}
                                        onClick={() => { return filterType ? props.sortResults('players', 'lastName') : null; }}
                                        data-testid="search.players.column-header.name"
                                    >
                                        <div className={`${isItGlobalSearch ? 'pl8' : ''}`}>{(filterType ? <span data-testid="search.players.column-header.name-label">Name <i className={`uts ${players.sort.field === 'lastName' && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} /></span> : <span data-testid="search.players.column-header.name-label">Players</span>)}</div>
                                    </div>
                                    <div className={`${isItGlobalSearch ? 'col-md-6' : 'col-md-7'} ${isClubMemberOrAdmin ? 'w-90' : ''} `}>
                                        <div className={`d-grid ${isClubMemberOrAdmin ? 'w-90' : 'w-100'}`} style={{ gridTemplateColumns }}>
                                            {userLoggedIn ? (
                                                <>
                                                    {tennis && (
                                                        <>
                                                            <div
                                                                className={`d-flex badge-wrapper-label align-items-center ${styles.searchHeaderColumn}  ${isMobileView ? styles.searchHeaderColumnForMobile : ''} ${styles.tagHover} ${filterType && styles.clickable} ${filterType && players.sort.field === getSinglesSortField() ? 'active' : ''}`}
                                                                onClick={() => { return (filterType && !isMobileView) ? sortDefaultDesc('players', getSinglesSortField()) : null; }}
                                                                data-testid="search.players.column-header.utr-singles-tennis"
                                                            >

                                                                UTR<img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthSingles} : '' `} src="/img/v3/icons/icon-singles-black.svg" data-testid="search.players.column-header.utr-singles-tennis.icon" /> {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getSinglesSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-singles-tennis.hover-text"> Singles Tennis Rating</span>
                                                            </div>

                                                            <div
                                                                className={`d-flex align-items-center ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''}  ${styles.tagHover} ${filterType && styles.clickable} ${filterType && players.sort.field === getDoublesSortField() ? 'active' : ''}`}
                                                                onClick={() => { return (filterType && !isMobileView) ? sortDefaultDesc('players', getDoublesSortField()) : null; }}
                                                                data-testid="search.players.column-header.utr-doubles-tennis"
                                                            >
                                                                UTR <img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthDoubles} : '' `} src="/img/v3/icons/icon-doubles-black.svg" data-testid="search.players.column-header.utr-doubles-tennis.icon" /> {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getDoublesSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-doubles-tennis.hover-text">Doubles Tennis Rating</span>

                                                            </div>
                                                        </>
                                                    )}

                                                    {pickleball && (
                                                        <>
                                                            <div
                                                                className={`d-flex align-items-center ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''}  ${styles.tagHover} ${filterType && styles.clickable} ${filterType && players.sort.field === getSinglePkbSortField() ? 'active' : ''}`}
                                                                onClick={() => { return (filterType && !isMobileView) ? sortDefaultDesc('players', getSinglePkbSortField()) : null; }}
                                                                data-testid="search.players.column-header.utr-singles-pickleball"
                                                            >
                                                                UTR-P <img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthSingles} : '' `} src="/img/v3/icons/icon-singles-black.svg" data-testid="search.players.column-header.utr-singles-pickleball.icon" />  {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getSinglePkbSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-singles-pickleball.hover-text">Singles Pickleball Rating</span>

                                                            </div>
                                                            <div
                                                                className={`d-flex align-items-center ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''} ${styles.tagHover} ${filterType && styles.clickable} ${filterType && players.sort.field === getDoublesPkbSortField() ? 'active' : ''}`}
                                                                onClick={() => { return (filterType && !isMobileView) ? sortDefaultDesc('players', getDoublesPkbSortField()) : null; }}
                                                                data-testid="search.players.column-header.utr-doubles-pickleball"
                                                            >
                                                                UTR-P <img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthDoubles} : '' `} src="/img/v3/icons/icon-doubles-black.svg" data-testid="search.players.column-header.utr-doubles-pickleball.icon" /> {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getDoublesPkbSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}

                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-doubles-pickleball.hover-text">Doubles Pickleball Rating</span>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {tennis && (
                                                        <>
                                                            <div className={`d-flex align-items-center  ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''}  ${styles.tagHover}`} data-testid="search.players.column-header.utr-singles-tennis">

                                                                UTR<img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthSingles} : '' `} src="/img/v3/icons/icon-singles-black.svg" data-testid="search.players.column-header.utr-singles-tennis.icon" /> {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getSinglesSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-singles-tennis.hover-text"> Singles Tennis Rating</span>

                                                            </div>
                                                            <div className={` d-flex align-items-center  ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''}  ${styles.tagHover}`} data-testid="search.players.column-header.utr-doubles-tennis">
                                                                UTR <img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthDoubles} : '' `} src="/img/v3/icons/icon-doubles-black.svg" data-testid="search.players.column-header.utr-doubles-tennis.icon" /> {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getDoublesSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-doubles-tennis.hover-text">Doubles Tennis Rating</span>
                                                            </div>
                                                        </>
                                                    )}
                                                    {pickleball && (
                                                        <>
                                                            <div className={` d-flex align-items-center  ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''}  ${styles.tagHover}`} data-testid="search.players.column-header.utr-singles-pickleball">
                                                                UTR-P <img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthSingles} : '' `} src="/img/v3/icons/icon-singles-black.svg" data-testid="search.players.column-header.utr-singles-pickleball.icon" />  {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getSinglePkbSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-singles-pickleball.hover-text">Singles Pickleball Rating</span>
                                                            </div>
                                                            <div className={`d-flex align-items-center  ${styles.searchHeaderColumn} ${isMobileView ? styles.searchHeaderColumnForMobile : ''}  ${styles.tagHover}`} data-testid="search.players.column-header.utr-doubles-pickleball">

                                                                UTR-P <img className={`${styles.iconMargin} ${isMobileView} ? ${styles.iconWidthDoubles} : '' `} src="/img/v3/icons/icon-doubles-black.svg" data-testid="search.players.column-header.utr-doubles-pickleball.icon" /> {(filterType && <i className={`uts d-none d-md-block ${players.sort.field === getDoublesPkbSortField() && !players.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}

                                                                <span className={`${styles.hoverText}`} data-testid="search.players.column-header.utr-doubles-pickleball.hover-text">Doubles Pickleball Rating</span>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                            <div className={`${styles.searchHeaderColumn}  ${showHeaderColumnsInMobile ? 'd-none' : ''} `} data-testid="search.players.column-header.additional-info">
                                                Additional Information
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!showHeaderColumnsInMobile && <div className="bookmark" />}

                        </div>
                    )}
                    <div className={`${styles.searchHeaders}  ${showHeaderColumnsInMobile ? 'd-none' : 'd-block d-md-none'}`} data-testid="search.players.column-headers-mobile">
                        {(filterType && showFilterDropDown !== 'hide') ? (
                            <div className={``} data-testid="search.players.sort-by-wrapper">
                                Sort by{' '}
                                <select
                                    className="inline-input"
                                    value={sortValue}
                                    onChange={(e) => sort(e.target.value)}
                                    data-testid="search.players.sort-select"
                                >
                                    <option value="">Relevance</option>
                                    {sortOptions.map((option) => <option value={option.value} key={option.value}>{option.label}</option>)}
                                </select>
                            </div>
                        ) : 'Players'}
                    </div>
                </div>
            ) : <div />
    );
};

PlayersHeaderColumns.propTypes = {
    // The search path passes the players slice as an object ({ total, sort, ... });
    // the club-members path passes an array of player records. Both are acceptable.
    players: PropTypes.instanceOf(Object).isRequired,
    sportTypes: PropTypes.instanceOf(Object),
    showFilterDropDown: PropTypes.string,
    showHeaderColumnsInMobile: PropTypes.bool,
    userLoggedIn: PropTypes.bool,
    filterType: PropTypes.string,
    utrType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    isClubMemberOrAdmin: PropTypes.bool,
    sortClubMembers: PropTypes.bool,
    isMobileView: PropTypes.bool,
    isItGlobalSearch: PropTypes.bool,
    sortValueForClubs: PropTypes.string,
};

PlayersHeaderColumns.defaultProps = {
    sportTypes: {},
    showFilterDropDown: '',
    showHeaderColumnsInMobile: false,
    userLoggedIn: false,
    filterType: '',
    utrType: '',
    isClubMemberOrAdmin: false,
    sortClubMembers: false,
    isMobileView: false,
    isItGlobalSearch: false,
    sortValueForClubs: '',
};

export default PlayersHeaderColumns;
